import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Send, CircleDashed } from "lucide-react";

const when = (s) => { if (!s) return ""; const d = new Date(s); return Number.isNaN(d.getTime()) ? s.slice(0, 10) : d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); };

export const SupplierSends = ({ rfqId, refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/rfqs/${rfqId}/supplier-sends`).then((r) => setD(r.data)).catch(() => {}); }, [rfqId, refreshKey]);
  if (!d?.suppliers?.length) return null;
  return (
    <div className="mt-4 rounded-lg border border-border bg-white p-4" data-testid="rfq-supplier-sends">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="font-heading text-sm font-bold text-slate-800">Supplier RFQs Sent</h3>
        <span className="font-mono text-xs text-[#1B4383]" data-testid="rfq-supplier-ref">Supplier Ref: {d.ref}</span>
      </div>
      <div className="divide-y divide-border">
        {d.suppliers.map((s) => (
          <div key={s.supplier_id} className="flex flex-col gap-0.5 py-2 text-sm sm:flex-row sm:items-center sm:justify-between" data-testid={`rfq-send-${s.supplier_id}`}>
            <span className="font-medium text-slate-800">{s.supplier_name}</span>
            {s.sent ? (
              <span className="flex items-center gap-1.5 text-xs text-emerald-700"><Send className="h-3.5 w-3.5" />Sent {s.ref}{s.last_at ? ` · ${when(s.last_at)}` : ""}{s.last_by ? ` · ${s.last_by}` : ""}{s.via ? ` · ${s.via}` : ""}{s.times > 1 ? ` · ${s.times}×` : ""}</span>
            ) : <span className="flex items-center gap-1.5 text-xs text-slate-400"><CircleDashed className="h-3.5 w-3.5" />Not Sent Yet</span>}
          </div>
        ))}
      </div>
    </div>
  );
};
